import type { Action } from 'redux';
import { selectIsPamNotificationStale } from 'client/js/redux/domains/AppStore';
import dash_api from 'client/js/main/support/dash_api';
import type { DataAction } from 'client/js/redux/types/dataAction.type';
import type { PamNotificationConfig, AppOrInheritedAttributionSettings } from '../../../../../../shared/types';
import type { GetState } from 'client/js/redux/services/ReduxAsyncAction';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { PamStateData } from '../types';

type Skip = { skip: true };

type FetchPamNotificationConfigActionPayload = PamStateData | Skip;

const FETCH_PAM_NOTIFICATION_CONFIG_NAMESPACE = 'FETCH_PAM_NOTIFICATION_CONFIG' as const;

const FetchPamNotificationConfig = new ReduxAsyncAction<
  typeof FETCH_PAM_NOTIFICATION_CONFIG_NAMESPACE,
  void,
  FetchPamNotificationConfigActionPayload
>(FETCH_PAM_NOTIFICATION_CONFIG_NAMESPACE);

FetchPamNotificationConfig.registerRequest(async (_, getState: GetState) => {
  const state = getState();
  const isStale = selectIsPamNotificationStale(state);

  if (!isStale) {
    return { skip: true } as Skip;
  }

  const [pamConfigResponse, attributtionWindowsResponse] = await Promise.all([
    dash_api.get<PamNotificationConfig>(`/v1/pam/notification`),
    dash_api.get<AppOrInheritedAttributionSettings | null>(`/v1/app/attribution-windows`),
  ]);

  return {
    ...pamConfigResponse.data,
    pamEnabled: !!attributtionWindowsResponse?.data?.predictive_aggregate_measurement_enabled,
    inherited: !!attributtionWindowsResponse?.data?.inherited,
  };
});

export const FETCH_PAM_NOTIFICATION_CONFIG = FetchPamNotificationConfig.actionNamespaceConstants;

export const fetchPamNotificationConfig = FetchPamNotificationConfig.request;

type FetchPamNotificationConfigRequestAction = Action<typeof FETCH_PAM_NOTIFICATION_CONFIG.request>;
type FetchPamNotificationConfigResponseAction = DataAction<
  typeof FETCH_PAM_NOTIFICATION_CONFIG.response,
  FetchPamNotificationConfigActionPayload
>;

export type FetchPamNotificationConfigAction =
  | FetchPamNotificationConfigRequestAction
  | FetchPamNotificationConfigResponseAction;
